import { getUserLocationsSimple } from "../api/graphql/locations";

export const getUserXCubes = async () => {
    const locations = await getUserLocationsSimple();
    return geXCubesForLocations(locations);
}

export const geXCubesForLocations = (locations) => {
    return locations.reduce((acc, location) => {
        const activeXcubes = location.xcubes.filter((xcube) => xcube.active);
        const cubes = activeXcubes.map((xcube) => ({
            ...xcube,
            location: location,
            name: `${xcube.name}(${xcube.letter}) - ${location.name} `,
        }));
        return acc.concat(cubes);
    }, []);
}